<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import BasicButton from '~/components/form-elements/BasicButton.vue'
import BasicTextarea from '~/components/form-elements/BasicTextarea.vue'
import BasicTextareaDecorator from '~/components/form-elements/BasicTextareaDecorator.vue'
import Auth from '~/components/modal-windows/Auth.vue'
import AuthAction from '~/enums/auth-action'
import UserPermission from '~/enums/user-permission'
import { useAuthStore } from '~/store/auth'
import { useProductQuestionsStore } from '~/store/product-questions'
import { useUserStore } from '~/store/user'

const props = defineProps<{
  productId: string | null
}>()

const textareaFocused = ref<boolean>(false)

const authStore = useAuthStore()
const productQuestionsStore = useProductQuestionsStore()
const userStore = useUserStore()

async function openAuthModalWindow (): Promise<void> {
  await useModal({ component: Auth, attrs: { action: AuthAction.SignIn } }).open()
}

async function saveChanges (): Promise<void> {
  productQuestionsStore.form.productId = props.productId

  await productQuestionsStore.createProductQuestion()
}
</script>

<template>
  <div v-if="authStore.isUser" class="mb-4 rounded-xl bg-[#F6F6F6] px-5 py-6">
    <b class="mb-3 block text-[22px] font-medium leading-[1.27] text-main-dark">
      Задайте вопрос о&nbsp;товаре
    </b>

    <p class="!mb-5 block text-sm leading-[1.33] tracking-[-0.01em] text-main-silver md:text-base md:leading-normal">
      Пришлём уведомление, когда поступит ответ от&nbsp;iTAB
    </p>

    <form @change="productQuestionsStore.hasUnsavedChanges = true" @submit.prevent>
      <BasicTextareaDecorator>
        <BasicTextarea
          v-model="productQuestionsStore.form.question"
          is-required
          :max-length="1000"
          placeholder="Напишите свой вопрос"
          :rows="textareaFocused || productQuestionsStore.form.question?.length ? 6 : 1"
          @focus-down="textareaFocused = false"
          @focus-up="textareaFocused = true"
        />
      </BasicTextareaDecorator>
    </form>

    <template v-if="textareaFocused || productQuestionsStore.form.question?.length">
      <div class="my-2 flex w-full items-center justify-between">
        <div class="text-sm leading-[1.71] text-main-dark">
          Символов&nbsp;{{ productQuestionsStore.form.question?.length }}/1000
        </div>
      </div>

      <BasicButton
        v-if="userStore.hasPermission(UserPermission.ClientCreateProductQuestion)"
        class="mt-4 min-h-[56px] !w-min !text-nowrap !rounded-2xl !px-8"
        color="green"
        :is-loading="productQuestionsStore.isLoading"
        title="Отправить вопрос"
        @click="saveChanges"
      />
    </template>
  </div>
  <a
    v-else
    class="
      inline-block w-min text-nowrap rounded-2xl bg-main-gray-low px-8 py-4 text-center text-base font-medium
      leading-normal tracking-[-0.01em] text-main-green !no-underline
    "
    href="#"
    @click.prevent="openAuthModalWindow"
  >
    Войдите, чтобы задать вопрос
  </a>
</template>
